<template lang="pug">
  .social-list(:class="{'social-list_opacity': opacity}")
    a.social-list__item(v-for="social in socials", :href="social.link" target="_blank" rel="noopener noreferrer")
      i(:class="[`icon-${social.icon}`, theme === 'blue' ? `icon-${social.icon}_blue` : '']")
</template>

<script>
export default {
  name: 'Social',
  props: ['opacity', 'theme'],
  data () {
    return {
      socials: [
        {
          icon: 'vk',
          link: 'https://vk.com/belkacar'
        },
        {
          icon: 'inst',
          link: 'https://www.instagram.com/belkacarru/'
        },
        {
          icon: 'fb',
          link: 'https://www.facebook.com/belkacarrus'
        },
        {
          icon: 'telegram',
          link: 'https://t.me/BelkaCar'
        },
        {
          icon: 'twitter',
          link: 'https://twitter.com/BelkaCar_ru'
        },
        {
          icon: 'yt',
          link: 'https://www.youtube.com/channel/UC7ZV8vglB4SnuYaTQQaiCiw'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Social.vue